/** @jsxImportSource react */
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const svg = require('!raw-loader!./PRMR.svg').default;
const PRMRLogo = (props) => (
  <div
    dangerouslySetInnerHTML={{ __html: svg }}
    {...props}
    data-tp-id='gen-div-1a428561-d55e-48b2-8e06-0f17a2a92cc3'
  />
);

PRMRLogo.defaultProps = {
  palette: 'primary',
};

export default PRMRLogo;
